import type { FilterConfig, GenericFilterValues } from "./generic-filter";
import { CheckboxGroup } from "../checkbox-group/checkbox-group";
import type { SelectOptionValue } from "../inputs/select/select";

type Props<TData, TFilterKey extends keyof TData = keyof TData> = {
  localFilters: GenericFilterValues<TData, TFilterKey>;
  filterConfigs: FilterConfig<TData, TFilterKey>[];
  onCheckboxChange: (category: TFilterKey, value: SelectOptionValue, checked: boolean) => void;
  gridCols?: string;
};

export const GenericFilterBody = <TData, TFilterKey extends keyof TData = keyof TData>({
  localFilters,
  filterConfigs,
  onCheckboxChange,
  gridCols = "grid-cols-3",
}: Props<TData, TFilterKey>) => {
  return (
    <div className={`grid ${gridCols} max-md:grid-cols-2 max-sm:grid-cols-1`}>
      {filterConfigs.map((config) =>
        config.options.length > 0 ? (
          <CheckboxGroup
            key={config.key as string}
            title={config.title}
            options={config.options}
            selectedValues={localFilters[config.key]?.map(String) || []}
            onCheckboxChange={(value, checked) => onCheckboxChange(config.key, value, checked)}
            idPrefix={config.key as string}
            checkboxClassName="border-2 text-gxe-primary text-2xl"
            className={config.className}
            labelClassName="text-gxe-gray cursor-pointer font-semibold"
          />
        ) : null
      )}
    </div>
  );
};
